import { render, staticRenderFns } from "./summary-product-item.vue?vue&type=template&id=3ab7e964&scoped=true"
import script from "./summary-product-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary-product-item.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./summary-product-item.vue?vue&type=style&index=0&id=3ab7e964&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7e964",
  null
  
)

export default component.exports